/**
 * shopAlias – compiled from feature-lsp.ts
 * Returns TLD (e.g. DK, NO) from window.theme.tld for multi-store logic.
 */
(function () {
  if (typeof window.theme === 'undefined') return;

  window.theme.shopAlias = function shopAlias() {
    const domain = window.theme.tld;
    const tld = domain.split('.').pop().toUpperCase();
    return tld;
  };
})();
